import { useCurrent } from '@/hooks/useCurrent';

export const useGetAbsoluteUrl = () => {
  const current = useCurrent();

  const absoluteUrl = current.tenant?.absoluteUrl;

  const getAbsoluteUrl = absoluteUrl
    ? (path?: string): string => {
        const cleanedPath = path
          ? path.startsWith('/')
            ? path
            : `/${path}`
          : '/';
        return `${absoluteUrl}${cleanedPath}`;
      }
    : null;

  return {
    getAbsoluteUrl,
    loading: current.loading,
  };
};
